module.exports = __webpack_public_path__ + "img/Logo_MezclaBrava_Slogan.aa445832.png";